// Custom js for sub menu open
var searchOpen = document.querySelector('.primary-menu .astm-search-menu .search-close')
var search = document.querySelector('.primary-menu .astm-search-menu')
var bodyTag = document.querySelector('#site-header')


if(searchOpen){
  searchOpen.addEventListener('click', function() {
        search.classList.toggle('active');
        bodyTag.classList.toggle('search-open');
  });
}

